import { html } from "lit-html";
import { unsafeHTML } from "lit-html/directives/unsafe-html";
import { useState } from "Shared/haunted/CustomHooks";
import { useReduxState } from "Shared/redux/useReduxState";
import { SmartBenefitsWidget, ValueField } from "./KenticoKontent";

export const useMobileBenefits = () => {
	const [kontent] = useReduxState("kontent.smartBenefits.smartBenefitsTest.contents");

	const [isMobileAccordionOpen, setIsMobileAccordionOpen] = useState<boolean>(false);

	const mobileAmericanWidgetTemplate = (widget: SmartBenefitsWidget) => {
		const handleNavigate = () => { window.location.href = widget.url.value; };

		return html`
		<div class="h-full w-full overflow-hidden rounded-lg border border-solid border-white px-4 py-2 text-white">
			<div class="text-center text-base font-bold">${unsafeHTML(widget.text.value)}</div>
			<div class="flex items-center justify-center gap-2 pt-2 text-lg font-medium">
				<span class="text-base" @click=${handleNavigate}>
					${widget.linktext.value}
				</span>
				<div
					class="h-[10px] w-[10px] rotate-45 transform border-r-2 border-t-2 border-solid border-white"
				></div>
			</div>
		</div>
	`;
	};

	const mobileAccordionContentTemplate = () => {
		const widgets = [kontent.widget[0]];

		return html` <div class="flex h-full gap-4 p-4">${widgets.map(mobileAmericanWidgetTemplate)}</div> `;
	};

	const mobileItemTemplate = (widget: SmartBenefitsWidget) => {
		const title = widget.titlemobile?.value || widget.title?.value || "MISSING";
		const icon = widget.iconmobile?.value || (widget.icon as ValueField).value || "MISSING";
		const handleNavigate = () => { window.location.href = widget.url.value; };

		return html`
			<div class="flex items-center gap-x-2" @click=${handleNavigate}>
				<div
					class="flex h-7 w-7 items-center justify-center gap-2 rounded-full bg-[#F0F3F7] text-xs text-n-blue"
				>
					${unsafeHTML(icon)}
				</div>
				<div class="text-sm text-n-blue">${unsafeHTML(title)}</div>
			</div>
		`;
	};

	const headerTitleTemplate = () => html`
		<div class="flex gap-2 text-white">
			<span class="text-lg/none">${unsafeHTML(kontent.widget[0].iconmobile.value)}</span
			><span class="text-base/none font-bold">${unsafeHTML(kontent.widget[0].titlemobile.value)}</span>
		</div>
	`;

	const handleAccordionToggle = () => setIsMobileAccordionOpen(!isMobileAccordionOpen);

	const htmlTemplate = () =>
		kontent
			? html`
					<div class="flex flex-col items-start gap-2 px-1">
						<dc-accordion
							class="w-full rounded-lg bg-n-blue p-2 text-white"
							.contentTemplate=${mobileAccordionContentTemplate}
							.headerIconClass=${"border-t-white"}
							.headerTitle=${headerTitleTemplate()}
							.hideBorder=${true}
							.isOpen=${isMobileAccordionOpen}
							.onClick=${handleAccordionToggle}
						></dc-accordion>
						${kontent.widget.slice(1).map(mobileItemTemplate)}
					</div>
			  `
			: "";

	return { htmlTemplate };
};
